import { EpimsBaseEntityDto } from './epim-base.dto';
export class ExpirationStatusDto extends EpimsBaseEntityDto {

    ExpirationStatusId: string;

    ExpirationStatusName: string;   

    Version: Number;

SubscriptionUserId: string;

}